import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { appEnvironment } from '@/configurations/app-configs/app.setting.config';
import CashAccountProfile from './CashAccountProfile/CashAccountProfile';
import AccountBalanceOneRow from '@/components/MyAccount/AccountBalance/AccountBalanceOneRow';
import CurrencyBalance from '@/components/MyAccount/CurrencyBalance/CurrencyBalance';
import FundManagement from '@/components/MyAccount/FundManagement/FundManagement';
import { getSafe } from '@/helpers/global';
import AccountBalance from './AccountBalance/AccountBalance';
import '../../assets/styles/pages/my-account/my-account.scss';
import BlockControl from '@/components/BlockControl/BlockControl'
import RefreshIcon from '@/assets/images/icons/icon_refresh.png';
import PositionProportion from './PositionProportion/PositionProportion'
class AccountBalanceAction extends React.Component {
    constructor(props) {
        super(props);
        // props.innerRef(this);
        this.state = {
          pageID: 0
        }
    }
    getNav = () => {
        const {language} = this.props;
        const {pageID} = this.state;
        const nav = [
            {id: 0, label: getSafe(() => language.market_stocks_and_funds)},
            // {id: 1, label: getSafe(() => language.account_stock_fund)}
        ]
        let navDivList = [];
        nav.map(item => {
            navDivList.push(
                <div onClick={() => this.setState({pageID: item.id},() => {this.getData()})}
                    key={item.id} 
                    className={classnames("account-balance-tab-item", pageID === item.id ? "active" : '')}>
                        {item.label}
                </div>
            )
        })
        return navDivList;
    }

    getData = () => {
        if(this.CashAccountProfileRef){
            this.CashAccountProfileRef.getAccountBalance();
        }
        if(this.PositionProportionRef){
            this.PositionProportionRef.getData();
        }
        if(this.AccountBalanceRef){
            this.AccountBalanceRef.getAccountBalanceData();
        }
    }

    render() {
        const {nav} = this.state;
        return (
            <div className='account-balance-action'>
                <div className='account-balance-tab section'>
                    <div className='account-balance-tab-div'>
                        {this.getNav()}
                    </div>
                    <div className='account-balance-tab-refresh'>
                    <img onClick={() => this.getData()}
                        className="pointer img-icon-12" src={RefreshIcon} alt='refresh_icon' />
                    </div>
                </div>
                <div className='account-balance-content'>
                    {
                    this.props.enableOneRowAccountBalance && <AccountBalanceOneRow />
                    }
                    {
                    <BlockControl name='my-account'>
                        {appEnvironment.custom_ctr_configs.accountCtr.enabledAccountProfile && <CashAccountProfile 
                            innerRef={e => this.CashAccountProfileRef = e}/>}
                    </BlockControl>
                    }
                    {
                        <PositionProportion
                            innerRef={e => this.PositionProportionRef = e}/>
                    }
                    {
                    appEnvironment.custom_ctr_configs.accountCtr.enabledCurrencyBalance && <CurrencyBalance />
                    }
                    {
                    appEnvironment.custom_ctr_configs.accountCtr.enabledAccountBalance && <AccountBalance 
                            innerRef={e => this.AccountBalanceRef = e}/>
                    }
                    {
                    appEnvironment.custom_ctr_configs.accountCtr.enabledFund && <FundManagement />
                    }
                </div>
            </div>
        );
    }
}
 
export default connect(
    state => ({
        language: state.app.language,
    }),
    dispatch => ({
    })
)(AccountBalanceAction)